export const BULK_COST_PRECISION  = 9

export const TASK_DESCRIPTION_MAX_LENGTH = 10240
export const TASK_NOTES_MAX_LENGTH = 2048
export const REFRESH_PERIOD = "30 seconds"

export const CategoryType = {
    Wholesale: 0,
    Packaged: 2,
    Supplies: 3,
    Label: [
        'Bulk/Wholesale',
        'NOT USED',
        'Packaged',
        'Supplies'
    ]
}

export const StrainType = {
    Indica: 0,
    Sativa: 1,
    Hybrid: 2,
    Label: [
        'Indica',
        'Sativa',
        'Hybrid'
    ]
}

export const UnitType = {
    Each: 0,
    Gram: 1,
    MilliLiter: 2,
    Liter: 3,
    Lbs: 4,
    Label: [
        'Each',
        'g',
        'mL',
        'L',
        'lbs',
    ],
    SingularLabel: [
        'Each',
        'g',
        'mL',
        'L',
        'lb',
    ]
}

export const ProductType = {
    Flower: 0,
    PreRoll: 1,
    Beverage: 2,
    Wellness: 3,
    Extract: 4,
    InfusedPreroll: 5,
    InfusedFlower: 6,
    Vape: 7,
    Edible: 8,
    Clothing: 9,
    Label: [
        "Flower",
        "PreRoll",
        "Beverage",
        "Wellness",
        "Extracts",
        "Infused Preroll",
        "Infused Flower",
        "Vape",
        "Edible",
        "Clothing/Appareal",
    ]
}

export const ProductSubType = {
    "ZERO": 0,
    "ThreePointFiveGram": 1,
    "SevenGram": 2,
    "FourteenGram": 3,
    "TwentyEightGram" : 4,
    "LBs" : 5,
    "PointSevenFiveGram": 6,
    "PointFiveGram": 7,
    "TwoPointFiveGram": 8,
    "TenMilligram": 9,
    "TwentyFiveMilligram": 10,
    "HundredMilligram": 11,
    "OneGram": 12,
    "Bulk": 13,
    "Liters": 14,
    "TwoGram": 15,
    "XS": 16,
    "S": 17,
    "M": 18,
    "L": 19,
    "XL": 20,
    "XXL": 21,
    "XXXL": 22,
    Label: [
        "ZERO",
        "3.5g",
        "7g",
        "14g",
        "28g",
        "LBs",
        ".75g",
        ".5g",
        "2.5g",
        "10mg",
        "25mg",
        "100mg",
        "1g",
        "Bulk",
        "Liters",
        "2g",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL",
    ]
}


export const InvoiceStatusType = {
    Created: 0,
    PaymentPending: 1,
    PartialPayment: 2,
    FullPayment: 3,
    Complete: 4,
    Label: [
        'Created',
        'Payment Pending',
        'Partially Paid',
        'Fully Paid',
        'Complete',
    ]
}

export const PurchaseOrderStatusType = {
    Created: 0,
    Fulfillment: 1,
    Complete: 2,
    Verified: 3,
    Label: [
        'Created',
        'Fulfillment',
        'Complete',
        'Verified'
    ]
}

export const PurchaseOrderItemStatusType = {
    Requested: 0,
    InProgress: 1,
    Complete: 2,
    Verified: 3,
    Label: [
        'Requested',
        'In-Progress',
        'Complete',
        'Verified'
    ]
}

export const BulkSizeType = {
    Bigs: 0,
    Smalls: 1,
    Clippings: 2,
    Label: [
        "Bigs",
        "Smalls",
        "Clipping"
    ]
}

export const PaymentStatusType = {
    Recorded: 0,
    Verified: 4,
    Label: [
        "Recorded",
        "", "", "",
        "Verified"
    ]
}

export const TaskStatusType = {
    Created: 0,
    Assigned: 1,
    InProgress: 2,
    Complete: 3,
    Verified: 4,
    Label: [
        "Created",
        "Assigned",
        "In-Progress",
        "Complete",
        "Verified"
    ]
}

export const InventoryAdjustmentType = {
    Add: 0,
    Subtract: 1,
    Set: 2
}

export const getOptions = (x) => () => {
    let options = [];
    let labels = x["Label"];

    for (const v of Object.values(x)) {
        if (typeof v === "number") {
            const opt = {
                value: v,
                label: labels[v]
            }
            options.push(opt);
        }
    }

    return options;
}